import React from 'react'
import './Contact-Us.css'

export default function ContactUs() {
  return (
    <div className="cu-page">
      <header className="cu-header">
        <h1 className="cu-header__title">Contact Us</h1>
      </header>

      <main className="cu-content">
        <section className="cu-hero">
          <h2>We&rsquo;re Here to Help You Grow Faster</h2>
          <p>
            Have questions about Leadszora? Need help with your account, leads,
            or platform access? Our support team is always ready to assist you.
          </p>
          <p>We typically respond within 24-48 business hours.</p>
          <p className="cu-hero__legal">
            For legal or compliance-related inquiries, please contact{' '}
            <a href="mailto:support@leadszora.com">support@leadszora.com</a>
          </p>
        </section>

        <section className="cu-cards" aria-label="Contact details">
          <article className="cu-card">
            <div className="cu-card__icon" aria-hidden>
              ✉️
            </div>
            <h3>Customer Support</h3>
            <p>Reach us anytime via our support channel</p>
            <a href="mailto:support@leadszora.com">support@leadszora.com</a>
          </article>

          <article className="cu-card">
            <div className="cu-card__icon" aria-hidden>
              🕒
            </div>
            <h3>Support Hours</h3>
            <p>Monday - Saturday</p>
            <p>Anytime</p>
          </article>

          <article className="cu-card">
            <div className="cu-card__icon" aria-hidden>
              📍
            </div>
            <h3>Location</h3>
            {/* <p>Surat, Gujarat</p> */}
            <p>India</p>
          </article>
        </section>
      </main>

      <footer className="cu-footer">
        <div className="cu-footer__inner">
          <span>Copyright &copy; Leadszora 2026</span>
          <nav aria-label="Legal links">
            <a href="/">Home</a>
            <span>|</span>
            <a href="/2.0privacy-policy">Privacy Policy</a>
            <span>|</span>
            <a href="/2.0Terms-of-Service">Terms &amp; Conditions</a>
            <span>|</span>
            <a href="/2.0Earning-Disclaimer">Earning Disclaimer</a>
            <span>|</span>
            <a href="/2.0Contact-Us">Contact Us</a>
          </nav>
        </div>
      </footer>
    </div>
  )
}
